import {CognitoUserPool} from 'amazon-cognito-identity-js'


const poolData = {
  UserPoolId: process.env.REACT_APP_AWS_USER_POOL_ID as string,
  ClientId: process.env.REACT_APP_AWS_USER_POOL_WEBCLIENT_ID as string,
};

const userPool: CognitoUserPool = new CognitoUserPool(poolData);
export default userPool;